// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_DateTime from "../Data.DateTime/index.js";
import * as Data_DateTime_Instant from "../Data.DateTime.Instant/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as DateUtils from "../DateUtils/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Now from "../Effect.Now/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
var UTCTime = function (x) {
    return x;
};
var unscrambleDecodeUTCTime = {
    unsafeDecode: function (value) {
        var str = Unscramble.decodeString(value);
        var v = DateUtils.parseISODateTime(str);
        if (v instanceof Data_Maybe.Just) {
            return v.value0;
        };
        if (v instanceof Data_Maybe.Nothing) {
            return Unscramble.decodingError("Invalid ISO8601 datetime: " + Data_Show.show(Data_Show.showString)(str));
        };
        throw new Error("Failed pattern match at Data.UTCTime (line 42, column 7 - line 44, column 78): " + [ v.constructor.name ]);
    }
};
var ordUTCTime = Data_DateTime.ordDateTime;
var now = function (dictMonadEffect) {
    return Effect_Class.liftEffect(dictMonadEffect)(Data_Functor.map(Effect.functorEffect)(function ($15) {
        return UTCTime(Data_DateTime_Instant.toDateTime($15));
    })(Effect_Now.now));
};
var newtypeUTCTime = {
    Coercible0: function () {
        return undefined;
    }
};
var showUTCTime = {
    show: /* #__PURE__ */ (function () {
        var $16 = Data_Newtype.unwrap();
        return function ($17) {
            return DateUtils.formatISODateTime($16($17));
        };
    })()
};
var toUnixTimestamp = /* #__PURE__ */ (function () {
    var $18 = Data_Newtype.unwrap();
    var $19 = Data_Newtype.unwrap();
    return function ($20) {
        return $18(Data_DateTime_Instant.unInstant(Data_DateTime_Instant.fromDateTime($19($20))));
    };
})();
var genericUTCTime = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var fromUTCTime = function (v) {
    return v;
};
var eqUTCTime = Data_DateTime.eqDateTime;
var encodeUTCTime = {
    encode: /* #__PURE__ */ (function () {
        var $21 = Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode);
        var $22 = Data_Newtype.unwrap();
        return function ($23) {
            return $21(DateUtils.formatISODateTime($22($23)));
        };
    })()
};
var decodeUTCTime = {
    decode: function (value) {
        return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Generic_Class.decode(Foreign_Generic_Class.stringDecode)(value))(function (str) {
            var v = DateUtils.parseISODateTime(str);
            if (v instanceof Data_Maybe.Just) {
                return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(v.value0);
            };
            if (v instanceof Data_Maybe.Nothing) {
                return Foreign.fail(Data_Identity.monadIdentity)(new Foreign.ForeignError("Invalid ISO8601 datetime: " + Data_Show.show(Data_Show.showString)(str)));
            };
            throw new Error("Failed pattern match at Data.UTCTime (line 33, column 5 - line 35, column 84): " + [ v.constructor.name ]);
        });
    }
};
var boundedUTCTime = Data_DateTime.boundedDateTime;
export {
    UTCTime,
    toUnixTimestamp,
    fromUTCTime,
    now,
    genericUTCTime,
    newtypeUTCTime,
    eqUTCTime,
    ordUTCTime,
    boundedUTCTime,
    showUTCTime,
    decodeUTCTime,
    unscrambleDecodeUTCTime,
    encodeUTCTime
};
//# sourceMappingURL=index.js.map
